import React, { useEffect, useState } from "react";



export default function SubmitButton({ sending, ...props }) {

  const [showMessage, setShowMessage] = useState(false)

  useEffect(function() {
    if(sending){
      setShowMessage(true)

      setTimeout(function() {
        setShowMessage(false)
      }, 3000)
    }
  }, [sending])

  return (
    <>
      {sending ? (
        <div className="btn btn-success disabled">
          <i className="fa fa-spinner fa-spin fa-fw"/>{" "}{props.labelSending ? props.labelSending : "Sending..."}
        </div>

      ) : (
        <>
          <button type="submit" className="btn btn-success">
            {showMessage ? ( 
              <>
                <i className="fa fa-check fa-fw"></i>{" "}{props.labelSent ? props.labelSent : "Sent!"}
              </>
            ) : (
              <>
                <i className="fa fa-save fa-fw"/>{" "}{props.labelDefault ? props.labelDefault : "Save"}
              </>
            )}
          </button>
        </>
      )}
    </>
  )
}

